import React from "react";

function ShareModal({ open, onClose, link }) {
  if (!open) return null;

  const defaultSiteUrl = "https://collegerank.in";
  let shareMessage;
  let primaryUrlInMessage;

  if (link && typeof link === 'string' && link.trim() !== '') {
    // If a specific link is provided, use a message tailored to sharing that page
    primaryUrlInMessage = link;
    shareMessage = `📢 Check out this page on College Rank! 🎓

Find valuable information and resources here:
${primaryUrlInMessage}

College Rank helps EAPCET & TS EAMCET students:
✨ Prioritize college lists
📊 Use Safety Margin for Safe, Moderate, or Ambitious options
🔍 Search & Filter by place, branch, and colleges
💾 Save, share, or download lists as PDF

Share this with friends who need it! 🙌
`;
  } else {
    // Default message if no specific link is passed
    primaryUrlInMessage = defaultSiteUrl;
    shareMessage = `📢 Attention EAPCET & TS EAMCET Students! 🎓

Struggling to find the right engineering college? Use College Rank to predict colleges based on your rank, caste, and past cut-offs! 🔍

✨ Prioritize your college list
📊 Use Safety Margin to explore Safe, Moderate, or Ambitious options
🔍 Search & Filter by place, branch, and colleges
💾 Save, share, or download your list as PDF

Get ready for counseling with the best tool for Andhra Pradesh & Telangana students! 🚀

👉 Visit: ${primaryUrlInMessage}

Share this with friends who need it! 🙌
`;
  }

  const handleCopy = async () => {
    await navigator.clipboard.writeText(shareMessage);
    alert("Share message copied to clipboard!");
  };

  const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(shareMessage)}`;
  // For Discord, direct message links are tricky and often don't prefill text.
  // A common approach is to guide users to copy-paste.
  // However, if you want to try, it's usually for server channels, not DMs.
  // For simplicity and reliability, we'll keep the copy-paste for Discord.
  const twitterUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(shareMessage)}`;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40 p-4">
      <div className="bg-white rounded-xl shadow-lg p-6 max-w-md w-full relative">
        <button
          onClick={onClose}
          className="absolute top-3 right-3 text-gray-400 hover:text-gray-600 text-2xl leading-none"
          aria-label="Close modal"
        >
          &times;
        </button>
        <h3 className="text-lg font-bold mb-4 text-center">Share With Friends</h3>
        <div className="flex flex-col gap-3">
          <a
            href={whatsappUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="w-full flex items-center justify-center bg-green-500 text-white py-2.5 px-4 rounded-lg font-semibold hover:bg-green-600 transition-colors"
          >
            <img
              src="https://cdn.jsdelivr.net/gh/simple-icons/simple-icons/icons/whatsapp.svg"
              alt="WhatsApp"
              className="h-5 w-5 mr-2 filter invert" // Invert for better visibility on green
            />
            Share on WhatsApp
          </a>
          <a
            href="https://www.instagram.com/" // Instagram does not support pre-filled text via URL
            target="_blank"
            rel="noopener noreferrer"
            className="w-full flex items-center justify-center bg-gradient-to-r from-pink-500 via-red-500 to-yellow-500 text-white py-2.5 px-4 rounded-lg font-semibold hover:opacity-90 transition-opacity"
            onClick={(e) => {
              e.preventDefault(); // Prevent navigation
              handleCopy();
              alert("Message copied! Please paste it in your Instagram story or DM.");
              window.open("https://www.instagram.com/", "_blank");
            }}
            title="Copy message and open Instagram. Paste the message in your story or DM."
          >
            <img
              src="https://cdn.jsdelivr.net/gh/simple-icons/simple-icons/icons/instagram.svg"
              alt="Instagram"
              className="h-5 w-5 mr-2 filter invert" // Invert for better visibility
            />
            Share on Instagram
          </a>
          {/* <a
            href={twitterUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="w-full flex items-center justify-center bg-blue-400 text-white py-2.5 px-4 rounded-lg font-semibold hover:bg-blue-500 transition-colors"
          >
            <img
              src="https://cdn.jsdelivr.net/gh/simple-icons/simple-icons/icons/twitter.svg"
              alt="Twitter"
              className="h-5 w-5 mr-2 filter invert" // Invert for better visibility
            />
            Share on Twitter
          </a> */}
          {/* Discord direct message prefill is unreliable, so copy is better */}
          {/* <button
            onClick={() => {
                handleCopy();
                alert("Message copied! Please paste it in Discord.");
                // Optionally open Discord app/website
                // window.open("https://discord.com/app", "_blank");
            }}
            className="w-full flex items-center justify-center bg-indigo-600 text-white py-2.5 px-4 rounded-lg font-semibold hover:bg-indigo-700 transition-colors"
          >
            <img
              src="https://cdn.jsdelivr.net/gh/simple-icons/simple-icons/icons/discord.svg"
              alt="Discord"
              className="h-5 w-5 mr-2 filter invert"
            />
            Copy for Discord
          </button> */}

          <button
            onClick={handleCopy}
            className="w-full flex items-center justify-center bg-gray-200 text-gray-800 py-2.5 px-4 rounded-lg font-semibold hover:bg-gray-300 transition-colors"
          >
            <svg
              className="h-5 w-5 mr-2"
              fill="none"
              stroke="currentColor"
              strokeWidth={2}
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M8 16h8M8 12h8m-7 8h6a2 2 0 002-2V6a2 2 0 00-2-2H7a2 2 0 00-2 2v12a2 2 0 002 2z"
              />
            </svg>
            Copy Message
          </button>
        </div>
        <div className="mt-4">
          <p className="text-xs text-gray-500 mb-1">Preview:</p>
          <textarea
            className="w-full p-2 border rounded text-xs bg-gray-50"
            rows={6}
            readOnly
            value={shareMessage}
          />
        </div>
      </div>
    </div>
  );
}

export default ShareModal;
